import { useContext, useEffect } from "react";

import { useRouter } from "next/router";
import useSWR from "swr";

import { Menu, Status } from "~components";
import { BaseContext } from "~context";
import { Event, getEvent, getRelease, Release } from "~graphql/fetchers";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { Detail as DetailV2 } from "~features/events/components/EventDetails/EventDetails";
import { useGoogleAnalyticsPageView } from "~hooks/useGoogleAnalytics";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";

type QueryParams = {
  eventId?: string;
  release?: string;
  slug?: string;
};

const EventInfoPage = () => {
  const router = useRouter();
  const query = router.query as QueryParams;
  const { organization } = useContext(BaseContext);

  const { error: eventError, data: event } = useSWR<Event, Error>(
    ["event", organization.id, router.query.eventId],
    getEvent
  );

  const { data: release, error: releaseError } = useSWR<Release, Error>(
    ["release", organization?.id, query.eventId, query.release, query.slug],
    getRelease
  );

  const isLoading = (!event && !eventError) || (!release && !releaseError);
  const isInactive = event?.isActive === false;

  useEffect(() => {
    if (isInactive) {
      void router.push("/");
    }
  }, [isInactive]);

  useCampaignReportingOpen(!isLoading);
  useGoogleAnalyticsPageView(router.query.eventId as string);
  useEventTrackingCodes();

  return (
    <>
      <Menu />
      <Status loading={isLoading || isInactive} error={eventError}>
        {!isLoading && <DetailV2 event={event} release={release} />}
      </Status>
    </>
  );
};

export default EventInfoPage;
